export const CONTENT_MODULES = {
  CARBON_IMPACT: 'CARBON_IMPACT',
  CULTURE: 'CULTURE',
  PLATFORM: 'PLATFORM',
  SOCIAL_IMPACT: 'SOCIAL_IMPACT',
  SUSTAINABILITY: 'SUSTAINABILITY',
  WELLBEING: 'WELLBEING',
}
